import React from 'react'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import PlaceHolder from 'components/share/PlaceHolder'
import { DisplayOption } from 'enums'

import { IndexWidgetsType } from '../../types'

// Remove this guard when implementing the index widget bubble display.

const IndexWidgetBubbleChartGuard: WidgetGuard = ({ widgetId, children }) => {
  const { displayOption } = useDashboardWidgetSetting<IndexWidgetsType>(widgetId)

  if (displayOption === DisplayOption.BUBBLE) {
    return <PlaceHolder />
  }
  return children
}

export default IndexWidgetBubbleChartGuard
